import { MiddleLayer } from './MiddleLayer';
import { HTTPServer } from './server/HTTPServer';
import { environment } from './env';

var serverURI = environment.serverUrl;
var bundleId = 'web';
if (window.dodConfig.serverURI) {
	serverURI = window.dodConfig.serverURI;
	console.log('default server URI: ' + serverURI);
}

const getR7DataFromQS = qs => ({
	sessionToken: qs?.get('sessionToken') || '4dc013c0e8526e6d3bcbb1d44924337ef48a707d',
	casinoId: 	qs?.get('casinoId') 	|| 'bbc',
	mode: 		qs?.get('casinoId') 	|| 'bbc',	// remove when server ready
	gameId: 	qs?.get('gameId') 		|| 'mini-game-1',
	ftue: 	qs?.get('showTutorial') 	|| 'True',
	dLoc: 		qs?.get('dLoc') 		|| 'fix',
	playerId: 	qs?.get('playerId') 	|| 'blob_8138'
});
var r7Data = getR7DataFromQS(null);

if (window.location.search) {
	let qs = new Map(
		decodeURI(window.location.search)
			.slice(1)
			.split('&')
			.map((p) => p.split(/=(.+)/))
	);

	let useAssignedServer = false;
	//optional assigned server
	if (useAssignedServer && qs.get('assignedServer')) {
		serverURI = qs.get('assignedServer');
		window.assignedServer = serverURI;
		console.log('found assignedServer sent in URL: ' + serverURI);
	} else if (qs.get('serverURI')) { //optional server URI sent via URL from wrapper (for QA debug menu)
		serverURI = qs.get('serverURI');
		console.log('found serverURI sent in URL: ' + serverURI);
	}
	if (qs.get('bundleId')) {
		bundleId = qs.get('bundleId');
		console.log('found bundleId sent in URL: ' + bundleId);
	}

	r7Data = getR7DataFromQS(qs);
}

export const comm = new MiddleLayer(new HTTPServer(serverURI), r7Data);

window.comm = comm;
window.serverURI = serverURI;
window.bundleId = bundleId;
